<template>
    <div class="body">
      <div class="header">
        <el-form :model="ImpositionFileDTO" :inline="true">
   
          <el-form-item>
            <el-button class="btn-style btn-cancel" type="primary" @click="tohandleEdit">新增</el-button>
            <el-button class="btn-style btn-delete"  type="danger" @click="handleDelete">删除</el-button>
          </el-form-item>
        </el-form>
  
        <el-dialog
        text-align: center
        :close-on-click-modal="false"
        title="编辑底板设置"
        :visible.sync="drawer"
        class="order-dialog"
        width=" 65%"
      >
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm form-style"
        >
   <el-row :gutter="24">
  <el-col :span="8">
          <el-form-item label="底板种类" prop="name">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.floor"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item  label="实际厚度" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.actualThickness"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
  </el-col>
  <el-col :span="8">
        <el-form-item  label="拼版价格" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>

<el-row :gutter="24">
  <el-col :span="8">
          <el-form-item   label="底板雕刻设置" prop="remark">
          <el-select clearable size="small" v-model="accountForm.schemeName">
            <el-option
              v-for="item in schemeName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
  <el-col :span="8">
    <el-form-item  label="出线孔" prop="outlet">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.outlet"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="8">
    <el-form-item  label="出水孔" prop="plughole">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.plughole"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>

<el-row :gutter="24">
    <el-col :span="8">
    <el-form-item  label="螺杆孔" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.screw"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
    <el-form-item  label="内缩值" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.diminution"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="8">
    <el-form-item  label="底板外扩" prop="footWall">
          <el-select clearable size="small" v-model="accountForm.footWall">
            <el-option
              v-for="item in footWall"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
</el-row>
<el-row :gutter="24">
  <el-col :span="8">
    <el-form-item  label="外扩值" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.wallValue"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
  
        <div style="display: flex">
       
          <!-- <el-button
            size="small"
            style="margin-left: 10px"
            type="primary"
            @click="exportExcelData"
          >
            导出
          </el-button> -->
         
        </div>
        
      </div>
      <div style="margin: 10px">
        <el-table
          :data="conTract"
          stripe
          border
          style="width: 100%"
          :cell-style="styleBack"
          @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          align="center"
          width="55"
        ></el-table-column>
          <el-table-column
            prop="floor"
            align="center"
            label="底板材料"
          ></el-table-column>
          <el-table-column
            prop="diminution"
            align="center"
            label="内缩值"
          ></el-table-column>
       
          <el-table-column
            prop="actualThickness"
            align="center"
            label="实际厚度"
          ></el-table-column>
          <el-table-column
            prop="density"
            align="center"
            label="密度"
          ></el-table-column>
          <el-table-column
            prop="price"
            align="center"
            label="拼版价格"
          ></el-table-column>
          <el-table-column
            prop="outlet"
            align="center"
            label="出线孔"
          ></el-table-column>
          <el-table-column
            prop="plughole"
            align="center"
            label="出水孔"
          ></el-table-column>
          <el-table-column
            prop="screw"
            align="center"
            label="螺杆孔"
          ></el-table-column>
          <el-table-column
            prop="footWall"
            align="center"
            label="底板外扩"
          ></el-table-column>
          <el-table-column
            prop="wallValue"
            align="center"
            label="外扩值"
          ></el-table-column>
          <el-table-column
            prop="schemeName"
            align="center"
            label="底板雕刻设置名称"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="设置时间"
            width="250"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="280">
          <template v-slot="{ row }">
            <el-link type="success" size="small" @click="handleEdit(row)">编辑</el-link>
          </template>
        </el-table-column>

         
        </el-table>
      </div>
  
      <el-dialog title="编辑底板设置" :visible.sync="dialogVisible"  width=" 65%" :close-on-click-modal="false"     class="order-dialog">
        <el-form
          ref="accountForm"
          :model="accountForm"
          label-width="100px"
          class="demo-accountForm form-style"
        >
   <el-row :gutter="24">
  <el-col :span="8">
          <el-form-item label="底板种类" prop="name">
            <el-input
              class="input-name"
              size="small"
              v-model="accountForm.floor"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item  label="实际厚度" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.actualThickness"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
  </el-col>
  <el-col :span="8">
        <el-form-item  label="拼版价格" prop="remark">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.price"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>

<el-row :gutter="24">
  <el-col :span="8">
          <el-form-item   label="底板雕刻设置" prop="remark">
          <el-select clearable size="small" v-model="accountForm.schemeName">
            <el-option
              v-for="item in schemeName"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
  <el-col :span="8">
    <el-form-item  label="出线孔" prop="outlet">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.outlet"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="8">
    <el-form-item  label="出水孔" prop="plughole">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.plughole"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>

<el-row :gutter="24">
    <el-col :span="8">
    <el-form-item  label="螺杆孔" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.screw"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
    <el-form-item  label="内缩值" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.diminution"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
        <el-col :span="8">
    <el-form-item  label="底板外扩" prop="footWall">
      <el-select clearable size="small" v-model="accountForm.footWall">
            <el-option
              v-for="item in footWall"
              clearable
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
      </el-col>
</el-row>
<el-row :gutter="24">
  <el-col :span="8">
    <el-form-item  label="外扩值" prop="screw">
          <el-input
            class="input-remark"
            size="small"
            v-model="accountForm.wallValue"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-col>
</el-row>
          <el-form-item >
            <el-button
              size="small"
              type="primary"
              @click="submitForm('accountForm')"
            >
              立即创建
            </el-button>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="editAccount()">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { selectFloor,upDateFloor,bathDeleteFile,addFloor,selectCarvingName} from '@/api/floor'
  export default {
    data() {
      return {
      direction: 'rtl',
        pageSize: 10,
        total: 0,
        currentPage: 1,
        multipleSelection: [],
        ids: '',
        drawer: false,
        access: '',
        date: '',
        dialogVisible: false,
        conTract: [],
        schemeName:[],
        footWall:["常规","加密"],
        accountForm: {
          actualThickness:'',
          density:'',
          price:'',
          diminution:'',
          schemeName:'',
          floor: '',
          id:'',
          access:''
        },
        ImpositionFileDTO:{
            startTime: '',
            endTime: '',
           
            status: '2'
        },
        searchForm: {
          startTime: '',
          secondStartTime: '',
          number: '',
          values: ''
        },
        DeleteDTO:{
          id:'',
        }
      }
    },
    
  
    mounted() {
      this.access=localStorage.getItem("access")
      this.accountForm.access=localStorage.getItem("access")
      this.getCarvingName()
      this.getTableData() // 进入页面调用一次获取数据的方法
    },
    methods: {
      styleBack({ row, column, rowIndex, columnIndex }) {
        // if (columnIndex == 0) {
        //   return { color: '#0c87ef' }
        // }
      },
      tohandleEdit(){
        this.accountForm = Object.assign({},this.$options.data().accountForm);
        this.accountForm.access=localStorage.getItem("access")
        this.drawer = true
      },
      getCarvingName(){
        selectCarvingName(this.access).then((res) => {
          this.schemeName = res.data.data
        //  this.total = Number(res.data.data.total)
        })
      },
      handleSizeChange(val) {
        // console.log(`每页 ${val} 条`)
        this.pageSize = val
        this.getTableData()
      },
      handleCurrentChange(val) {
        // console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getTableData()
      },
      getTableData() {
        selectFloor( this.access).then((res) => {
            console.log(res);
          this.conTract = res.data.data
        //  this.total = Number(res.data.data.total)
        })
      },
      // 导入
      loadFile(file, fileList) {
        const formdata = new FormData()
        fileList.map((item) => {
          // fileList本来就是数组，就不用转为真数组了
          formdata.append('file', item.raw) // 将每一个文件图片都加进formdata
        })
        leadingIn(formdata).then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
            this.getTableData()
          }
        })
      },
  
      handleEdit(row) {
        this.dialogVisible = true
        this.accountForm= row
      },
      submitForm(accountForm) {
        this.$refs[accountForm].validate((valid) => {
          if (valid) {
              addFloor(this.accountForm).then((res) => {
                  if (res.data.msg === '操作成功') {
              this.drawer = false
              this.$message({
                type: 'success',
                message: '添加成功!',
                
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      handleDelete() {
        if(this.multipleSelection.length==0){
              this.$message({
                type: "error",
                message: "sorry,你还没有勾选任何文件呢!"
              });
              return;
            } 
      this.$confirm('您真的确定要删除吗？\n\n请确认！！！！！', '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          bathDeleteFile(this.multipleSelection).then((res) => {
            if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              }),
              this.getTableData()
  
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
     
  
    
      deleteInfo(){
        bathDeleteFile(this.multipleSelection).then((res) => {
            if(res.data.code===10000){
              this.getTableData()
            }
        })
      },
      //修改
      editAccount() {
        upDateFloor(this.accountForm).then((res) => {
          console.log(res.status)
          if (res.data.msg === '操作成功') {
              this.$message({
                type: 'success',
                message: '修改成功!',
              }),
              this.getTableData()
              this.dialogVisible = false
            } else if (res.data.msg !== '操作成功') {
              this.$message({
                type: 'info',
                message: res.data.data
              })
            }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 导出
      exportExcelData() {
        exportData(this.searchForm, this.currentPage, this.total)
          .then((res) => {
            if (res.status == 200) {
              exportExcel(res.data, res)
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
            }
          })
          .catch((error) => {
            console.log(error)
          })
      },
      chooeDate(e) {
        // console.log(e)
        if (e) {
          this.ImpositionFileDTO.startTime = e[0]
          this.ImpositionFileDTO.endTime = e[1]
        } else if (!e) {
          this.ImpositionFileDTO.startTime = ''
          this.ImpositionFileDTO.endTime = ''
        }
      },
      // 搜索
      serchInfo() {
        this.getTableData()
      },
  
    
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin: 20px;
  }
  
  .body {
      overflow: auto;
  }
  
  .pagination {
      margin-top: 10px;
      margin-right: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: relative;
  }
  
  .el-pagination ::v-deep.el-pagination__total {
      line-height: 36px;
  }
  
  .el-table .warning-row {
      background: oldlace;
  }
  
  .el-table .success-row {
      background: #f0f9eb;
  }
  .goodsTableData{
      margin: 20px 0 ;
  }
  .btn-style{
      min-width: 72px;
      border-radius: 8px;
  }
  .btn-search{
      background: var(--theme-color);
  }
  .btn-buy{
      background: #FF8429;
  }
  .btn-print{
      background: #4093FF;
  }
  .btn-delete{
      background: #FF4D4D;
  }
  .btn-view{
      background: var(--theme-color);
  }
  .product-form .el-form-item{
      margin-bottom: 0;
  }
  .table-content{
      margin: 20px;
  }
  .check-all{
      color: #333;
      font-size: 16px;
      margin-right: 20px;
      cursor: pointer;
  }
  .el-pagination{
      margin: 0;
  }
  
  .el-date-editor , ::v-deep.el-select .el-input__inner , ::v-deep.el-input .el-input__inner{
      border-radius: 8px;
  }
  
  .table-label{
      color: var(--secondColor);
  }
  .table-value{
      color: var(--color);
  }
  .table-info{
      width: 80%;
      justify-content: space-between;
  }
  .table-info > p{
      display: inline-block;
      width: 150px;
      padding-right: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex-shrink: 0;
  }
  .table-item{
      background: #F7F7F7;
      margin: 8px 0;
      border-radius: 12px;
      padding: 12px;
  }
  .table-image{
      width: 100px;
      height: 50px;
      margin-right: 20px;
  }
  ::v-deep.table-image .image-slot{
      height: 50px;
      display: flex;
      align-items: center;
  }
  ::v-deep.table-image .image-slot i{
      font-size: 50px;
  }
  .pay{
      color:var(--theme-color);
  }
  .no-pay{
      color:#FF4D4D;
  }
  .btn-group{
      display: flex;
      flex-direction: column;
      gap: 10px;
  }
  .btn-group .el-button{
      border-radius: 20px;
      width: 76px;
  }
  .btn-collection{
      background: #F9DDDD;
  }
  .btn-view-detail{
      background: #D3F2E4;
      color: var(--theme-color);
  }
  .btn-reckon{
      background: rgb(245, 233, 212);
    
  }
  
  ::v-deep.order-dialog .el-dialog{
      border-radius: 24px;
  }
  .operator label{
      letter-spacing: 5px;
  }
  ::v-deep.dialog-upload{
      display: flex;
  }
  ::v-deep.dialog-upload .el-form-item__label{
      flex-shrink: 0;
  }
  ::v-deep.dialog-upload .el-form-item__content{
      justify-content: right;
  }
  ::v-deep.dialog-upload .avatar-uploader{
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid #D8E0DD;
  }
  ::v-deep.dialog-upload .el-upload--text{
      width: 100%;
      height: 100%;
  }
  ::v-deep.dialog-upload img{
      max-width: 100px;
  }
  .accountForm-header{
      background: #F7F7F7;
      border-radius: 16px;
      margin-bottom: 20px;
      padding: 20px;
  }
  .btn-add{
      background: #FF8429;
      border-radius: 8px;
  }
  .form-submit{
      background: var(--theme-color);
      border-radius: 8px;
  }
  ::v-deep.el-table thead th{
      background: #EAF4F0;
      color: var(--secondColor);
  }
  .table-no-pay{
      background: #ffeded;
  }
  
  ::v-deep.el-icon-remove-outline{
      font-size: 32px;
      color: #a3d8f9cc;
  }
  </style>
  